module.exports = __webpack_public_path__ + "img/Foodtag.877098fd.png";